// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../node_modules/less-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[1].rules[11].use[0]!./AiColorSwatches.vue?vue&type=style&index=0&id=f9bba520&lang=less&scoped=true");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("10bd2b75", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../node_modules/less-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[1].rules[11].use[0]!./AiColorSwatches.vue?vue&type=style&index=0&id=f9bba520&lang=less&scoped=true", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../node_modules/less-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[1].rules[11].use[0]!./AiColorSwatches.vue?vue&type=style&index=0&id=f9bba520&lang=less&scoped=true");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}